import ListTemplatePenunjangProduksi from './ListTemplatePenunjangProduksi';

export default ListTemplatePenunjangProduksi;
